$(document).on('click','.ftrtbns',function (e) {
  e.preventDefault();  
  $(this).toggleClass('active').siblings().removeClass('active');
  $('.ftr_dropdownlist[data-title="'+$(this).data('title')+'"]').slideToggle().siblings().slideUp();
  $('body').addClass('ftr-open');
});
$(document).on('click','.ftrclose_menu,.ftroverlay',function (e) {
  e.preventDefault();  
  $('body').removeClass('ftr-open');
  $('.ftr_dropdownlist').slideUp();
  $('.ftrtbns').removeClass('active');
});
var counttime = 0;
function cartNotification(cartId) {
  $.ajax({
    type: "GET",
    url: "?section_id=cart-notification",
    dataType: "HTML",
    success: function (data) {
      var temp_data = $(".cart_popup").html(data);
      var lastItem = $(".ch_items")
        .find(".cn_" + cartId)
        .html();
      $(".ch_items").html(lastItem);
      $("body").addClass("fillcart");
      counttime = 0;
      const myInterval = setInterval(timer, 1000);
      function timer() {
        counttime++;
        if (counttime > 9) {
          $(".cart_popup").html("");          
          myStop();
        }
      }
      function myStop() {
        clearInterval(myInterval);
      }      
    },
    error: function (error) {
      $(".cnerror").html(error.responseJSON.description);
    },
  });
}
$(document).on("click", ".variant-grid", function (e) {
  e.preventDefault();
  var grid_error = $(this).closest(".snippet-product-grid").find(".grid-error");
  var changevar_id = $(this).data("id");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: changevar_id, quantity: 1 },
    dataType: "json",
    success: function (data) {
      cartNotification(data.id);
      load_cart();
      $('.snippet-product-grid').removeClass('active');
      $('body').removeClass('mobile-gridvariants');
    },
    error: function (e, t) {
      grid_error.text(e.responseJSON.description);
      setTimeout(function () {
        grid_error.text("");
      }, 2000);
    },
  });
});
$(document).on("click", ".cn_close", function (e) {
  e.preventDefault();
  $(".cart_popup").html("");
});
function removeItem(data_line,qty){
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity="+qty+"&id=" + data_line,
    dataType: "json",
    beforeSend: function () {
        
    },
    success: function (e) {
      if(document.location.href.indexOf('/cart') > -1) {
          window.location.href = "/cart";
      }else{
        load_cart();
      }
    },
    error: function (e, t) {
      //console.log(e.responseJSON.description);              
    },
    complete: function(){
      
    }
  });
}
$(document).on('click','.cd_variantbtn',function (e) {
  e.preventDefault();
  $(this).next('.cd__variant_list').slideToggle().closest('.cartitems').siblings().find('.cd__variant_list').slideUp();
  $(this).toggleClass('active').closest('.cartitems').siblings().find('.cd_variantbtn').removeClass('active');
});
$(document).on('click','.cd_variant',function (e) {
  e.preventDefault();
  $(this).closest('.cartitems').find('.cd__variant_list').slideUp();
  $(this).closest('.cartitems').find('.cd_variantbtn').removeClass('active');
  var cart_error = $(this).closest('.cartitems').find('.cierror');
  var currentid = $(this).closest('.cartitems').find('.item-remove').data('line');
  var changevar_id = $(this).data('id');
  var item_current_qty = $(this).closest('.cartitems').find('.cart_qty').val();
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: changevar_id, quantity: item_current_qty },
    dataType: "json",
    beforeSend: function () {
    },
    success: function (t) {
      setTimeout(function(e){
        removeItem(currentid,0);
      },500);       
    },
    error: function (e, t) {
      cart_error.text(e.responseJSON.description);
      setTimeout(function(){
        cart_error.text('');
      },2000);
    },
    complete: function(){
    }
  });
});
$('body').on('click',function(e){   
  var cartvariant = $(".cd_variantbtn,.cd__variant_list");    
  if (!cartvariant.is(e.target) && cartvariant.has(e.target).length === 0){
    $('.cd__variant_list').slideUp();
    $('.cd_variantbtn').removeClass('active');
  }
  var ftrdropdowns = $('.ftr_dropdownlist,.ftrtbns');
  if (!ftrdropdowns.is(e.target) && ftrdropdowns.has(e.target).length === 0){
    $('body').removeClass('ftr-open');
    $('.ftr_dropdownlist').slideUp();
    $('.ftrtbns').removeClass('active');
  }
  var cartDrawervarList = $('.cpd_variantwrap');
  if (!cartDrawervarList.is(e.target) && cartDrawervarList.has(e.target).length === 0){
    $('.cpd_variantwrap').removeClass('active');
    $('body').removeClass('open-cdoverlay');
  }
});
$(document).on('click','.smallcartbtn',function (e) {
  e.preventDefault();
  $('.cpd_variantwrap').removeClass('active');
  // One size upsell products carry their only variant on the bag itself: add it straight away
  if ($(this).data('id')) {
    addUpsellVariant($(this), $(this).data('id'));
    return;
  }
  $(this).closest('.cart_pro_column').find('.cpd_variantwrap').addClass('active');
});
$(document).on('click','.cdbp_close,.cd_s_overlay',function (e) {
  e.preventDefault();
  $('.cpd_variantwrap').removeClass('active');
  $('body').removeClass('open-cdoverlay');
});
$(document).on('click','.cpvariant-grid',function (e) {
  e.preventDefault();
  addUpsellVariant($(this), $(this).data("id"));
});
function addUpsellVariant($trigger, variantId) {
  var $column = $trigger.closest(".cart_pro_column");
  var grid_error = $column.find(".grid-error");
  // Size picker cards show the error above their sizes; one size cards open an error-only overlay
  var $message = $column.find(".cpd_variantwrap--message");
  if ($trigger.data("adding")) return;
  $trigger.data("adding", true);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: variantId, quantity: 1 },
    dataType: "json",
    success: function (data) {
      if(document.location.href.indexOf('/cart') > -1) {
          window.location.href = "/cart";
      }else{
        load_cart();
      }
      $('body').removeClass('open-cdoverlay');
      $('.cpd_variantwrap').removeClass('active');
    },
    error: function (e, t) {
      grid_error.text(e.responseJSON.description);
      $message.addClass("active");
      setTimeout(function () {
        grid_error.text("");
        $message.removeClass("active");
      }, 2000);
    },
    complete: function () {
      $trigger.data("adding", false);
    },
  });
}
$(document).on('click','.mobile_quickcart',function (e) {
  e.preventDefault();
  $('.snippet-product-grid').removeClass('active');
  $(this).closest('.snippet-product-grid').addClass('active');
  $('body').addClass('mobile-gridvariants');
});
$(document).on('click','.mob_close_variant,.box-overlay',function (e) {
  e.preventDefault();
  $('.snippet-product-grid').removeClass('active');
  $('body').removeClass('mobile-gridvariants');
});
$(document).on('click','.cdp-header',function (e) {
  e.preventDefault();
  $('.cart_pro_listouter').slideToggle();
  $(this).toggleClass('active');
});
Weglot.on("languageChanged",function(t){
  $('body').removeClass('ftr-open');
  $('.ftr_dropdownlist').slideUp();
  $('.ftrtbns').removeClass('active');
});
$(document).on('click','.cn_btn a',function(e){
  e.preventDefault();
  $('body').addClass('open-drawer');
  $(".cart_popup").html("");
  $('.snippet-addto-cart').removeClass('successcart');
});
/*$(window).scroll(function() {
  $scroll_position = $(window).scrollTop();
  if ($scroll_position > 100) { 
    $(".cart_popup").html("");
    $('.snippet-addto-cart').removeClass('successcart');
  }
});*/
function loadWishlist() {
  $(document).on('click','.swym-wishlist-add-to-cart-btn',function (e) {
    setTimeout(function (e) {
      load_cart();
    }, 1000);
  });
  var wishlistCart = document.querySelector(".swym-add-to-cart-btn");
  if (wishlistCart) {
    var wishlistCartcls = document.querySelectorAll(".swym-add-to-cart-btn");
    wishlistCartcls.forEach(function (cartBtn) {
      cartBtn.addEventListener("click", function () {
        setTimeout(function (e) {
          load_cart();          
        }, 1000);
      });
    });
  } else {
    setTimeout(function (e) {
      loadWishlist();
    }, 1000);
  }
}
loadWishlist();
/*
 * "Style it with" upsell. Server rendered with bestsellers, then upgraded with the
 * complementary ("frequently bought together") recommendations of the last added cart item.
 * Keeps the server rendered products when no recommendations come back.
 */
class CartUpsell extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url || this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';
    this.loadIntent((this.dataset.intents || 'related').split(','), 0);
  }

  /*
   * Complementary products come from the Search & Discovery app and are empty until a
   * merchant sets them up, so fall through to the next intent whenever nothing comes back.
   */
  loadIntent(intents, index) {
    if (index >= intents.length) return;

    fetch(this.dataset.url + '&intent=' + intents[index])
      .then(function (response) {
        return response.text();
      })
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const source = html.querySelector('#cart-upsell-recommendations');
        const cards = source ? Array.from(source.children) : [];

        if (cards.length === 0) {
          this.loadIntent(intents, index + 1);
          return;
        }
        this.render(cards);
      })
      .catch((e) => {
        console.error(e);
        this.loadIntent(intents, index + 1);
      });
  }

  /* Recommendations lead, the server rendered bestsellers top the row up to the limit. */
  render(cards) {
    const limit = parseInt(this.dataset.limit, 10) || cards.length;
    const seen = [];
    const kept = [];

    cards.concat(Array.from(this.children)).forEach(function (card) {
      const id = card.dataset.productId;
      if (kept.length >= limit || (id && seen.indexOf(id) !== -1)) return;
      if (id) seen.push(id);
      kept.push(card);
    });

    this.replaceChildren.apply(this, kept);
    const wrapper = this.closest('.cartpro_cls');
    if (wrapper) wrapper.classList.remove('cartpro_cls--pending');
    if (typeof initCartDragScroll === 'function') initCartDragScroll();
  }
}
if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', CartUpsell);
}

function syncHeight() {
    document.documentElement.style.setProperty(
        '--window-inner-height',
        `${window.innerHeight}px`
    );
}
window.addEventListener('resize', syncHeight);